
import { Link, graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Box } from 'theme-ui';

import LinkIcon from '@src/assets/icons/ic_nuoroda.svg';
import { filterLocaleNodes } from '@src/i18n/localeList';

const InfoPageNav = ({ locale, heroImage }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulPuslapis(
        filter: { layout: { eq: "Informacinis puslapis" } }
      ) {
        totalCount
        nodes {
          node_locale
          slug
          title
        }
      }
    }
  `);
  // list only those pages who has unique slug in own language
  let navListToRender = [];
  const enNavList = filterLocaleNodes(data.allContentfulPuslapis.nodes, 'en');
  const contractPageSlugLt = 'paslaugu-tiekimo-sutartis';
  const contractPageSlugEn = 'contract-with-teacher';
  if (locale !== 'en') {
    const localeNavList = filterLocaleNodes(
      data.allContentfulPuslapis.nodes,
      locale
    );
    navListToRender = localeNavList.filter((localePage) => {
      return !enNavList.some((enPage) => enPage.slug === localePage.slug);
    });
    navListToRender = navListToRender.filter(
      (localePage) => localePage.slug !== contractPageSlugLt
    );
  } else {
    navListToRender = enNavList.filter(
      (localePage) => localePage.slug !== contractPageSlugEn
    );
  }

  return (
    <Box
      py={[3, 3, 4]}
      px={5}
      sx={{
        position: 'relative',
        zIndex: 1,
        boxShadow: '0px 10px 60px #0000001A',
        borderRadius: '10px',
        backgroundColor: 'white',
        transform: [
          null,
          'translateY(0)',
          heroImage ? 'translateY(-50%)' : 'translateY(30%)',
        ],
      }}
    >
      {navListToRender.map((item) => (
        <Box key={item.slug} my={3}>
          <Link
            sx={{
              color: 'text',
              textDecoration: 'none',
              fontSize: 3,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '20px',
              transition: '200ms ease-in',
              '&:hover': {
                color: 'primary',
              },
            }}
            to={`/${item.slug}`}
          >
            <LinkIcon /> {item.title}
          </Link>
        </Box>
      ))}
    </Box>
  );
};

export default InfoPageNav;
